import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Spinner } from '../../../../../shared/ui/Spinners';
import { ConfigureTile } from './ConfigureTile';
import { DescriptionTile } from './DescriptionTile';

/**
 * Uso:
 * - Componente de composição da tela de configuração (desktop e mobile).
 * - Recebe estado de aba, subcategoria e perguntas já processadas pelo container.
 *
 */
export const ResponsiveSelectPage = ({
    showTabOrder,
    setShowTabOrder,
    questions,
    subCategory,
}) => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 10);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div
                style={{
                    width: '100%',
                    textAlign: 'center',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                }}
            >
                <Spinner />
            </div>
        );
    }

    if (isTabletOrMobile) {
        return (
            <div style={{ display: 'block', width: '100%' }}>
                <div>
                    <DescriptionTile
                        subCategory={subCategory}
                        width="100%"
                        showTabOrder={showTabOrder}
                        setShowTabOrder={setShowTabOrder}
                    ></DescriptionTile>
                </div>
                <div style={{ marginTop: '15px' }}>
                    <ConfigureTile questions={questions} width="100%"></ConfigureTile>
                </div>
            </div>
        );
    }

    return (
        <div style={{ display: 'block', width: '100%' }}>
            <div className="panel-configuration" style={{ display: 'flex' }}>
                <ConfigureTile
                    questions={questions}
                    style={{ flex: '1', marginLeft: '10px', boxSizing: 'border-box' }}
                ></ConfigureTile>
                <DescriptionTile
                    subCategory={subCategory}
                    style={{ flex: '2', maxWidth: '300px' }}
                    showTabOrder={showTabOrder}
                    setShowTabOrder={setShowTabOrder}
                ></DescriptionTile>
            </div>
        </div>
    );
};
